<template>
    <div>
        <el-dialog @close="close" style="margin-left: 52%;overflow: inherit;top: -1.6rem !important;" class="el-dialog1"
                   :visible.sync="dialogVisible" width="98%">
            <div class="title" v-if="current !== '抬头纸上传'">
                <div @click="handlerSwithClick(item)" class="btns" :class="item === current ? 'active' : ''" v-for="(item, index) in swithBtn" :key="index">
                    {{ item }}
                </div>
            </div>
            <div class="container1" v-if="current === '抬头纸上传'">
                <div class="box">
                    <p class="p1">点击此处上传您的抬头纸页眉</p>
                    <ResourceUpload :parentId="String(parentId)" :showFlodNames="['抬头纸页眉']" ref="upload"
                                    ossRoute="companyImage" v-model="picList"
                                    :fileLimit="1" flodName="抬头纸页眉" listType='picture-card'>
                    </ResourceUpload>
                </div>
                <div class="box">
                    <p class="p1">点击此处上传您的抬头纸页脚</p>
                    <ResourceUpload :parentId="String(parentId)" :showFlodNames="['抬头纸页脚']" ref="upload1"
                                    ossRoute="companyImage" v-model="picList1"
                                    :fileLimit="1" flodName="抬头纸页脚" listType='picture-card'>
                    </ResourceUpload>
                </div>
            </div>
            <div v-else class="container2">
                <p class="p1">
                    请维护您在方案后会带出的共性内容
                    (前端word导出后，及小程序导出前可修改)
                </p>
                <div class="p2">
                    报价说明版本: <span class="span1">（点击名称查看展示效果)</span>
                    <p @click="handlerAddClick()" class="p3">新增</p>
                </div>
                <div class="priceSm">
                    <div class="priceSmText" v-for="(item, index) in schemeList" :key="index">
                        <p @click="handlerSelectClick(item, 'hu')" :class="datas.id === item.id ? 'active2' : ''"
                           class="p4">
                            {{ item.schemeName }}
                        </p>
                        <svg-icon @click="handlerSelectClick(item, 'hu')" class="svg" iconClass="edit"></svg-icon>
                        <svg-icon @click="handlerDeleteClick(item)" class="svg" iconClass="delete"></svg-icon>
                    </div>
                </div>
                <el-card  class="box-card">
                    <div style="max-height: 5.9rem; overflow-y: scroll">
                        <div class="line1">
                            <p class="p5">报价说明 版本名称</p>
                            <el-input v-model="datas.schemeName" size="small" placeholder="请输入内容"></el-input>
                        </div>
                        <div class="line1" v-for="(item, keys) in btnsList" :key="keys">
                            <div class="left">
                                <p class="p5" style="width: 1.5rem">{{ item.title }}</p>
                                <div @click="handlerAddBtnsClick(keys, item)" v-if="item.flag" class="btns">
                                    <span style="color: red; margin-right: 0.05rem">+</span>
                                    <span>加项</span>
                                </div>
                                <el-input v-model="addValue" @blur="inputBlue(item, keys)" size="medium" v-else style="width: 1.2rem"></el-input>
                            </div>
                            <draggable @add="addChange"  group="btns" class="right" @start="onStart($event, keys)" @end="onEnd($event, keys)" v-model="item.arr" animation="300">
                                <div v-for="(item1, index1) in item.arr" :key="index1">
                                    <div @contextmenu.prevent.stop="rightClick(item1)" class="btns" :class="selectDatas.budgetTitle === item1.budgetTitle && selectDatas.budgetDescType == keys ? 'active1': ''" @click="handlerSelectBtnClick(item1)">
                                        {{ item1.budgetTitle }}
                                        <img v-if="item1.budgetTitleContent.length > 0" class="checkIcon" :src="require('@/assets/png/btnRight.png')" alt=""/>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                        <div class="line"></div>
                        <div class="centerBox">
                            <div style="margin-bottom: 0.24rem">
                                <Ueditor v-if="isShow" class="myUeditor" :parentId="datas.id" @ueditorChange="ueditorChange" ref="ueditor"></Ueditor>
                            </div>
                        </div>
                    </div>
                    <div class="footerBottomBtns">
                        <el-button @click="handlerSelectClick(datas)" class="bnts1" plain>查看效果</el-button>
                        <el-button @click="save" class="btns2" plain>提交</el-button>
                        <el-button @click="dialogVisible = false" class="btns2" plain>取消编辑</el-button>
                    </div>
                </el-card>
            </div>
        </el-dialog>
        <offerDetailPopup ref="offerDetailPopup"></offerDetailPopup>
        <modifyChild @update="update" ref="modifyChild"></modifyChild>
    </div>
</template>

<script>
import PlanApi from "@/components/Api/PlanApi.js";
import offerDetailPopup from "../../../components/offerDetailPopup.vue";
import {getGroup, duplicateRemoval} from "@/assets/utils/unit.js";
import draggable from 'vuedraggable'
import modifyChild from './modifyChild.vue';
import ResourceUpload from "@/components/Upload/ResourceUpload.vue";
import Ueditor from "@/components/Editor/Ueditor.vue";

export default {
    name: "normsMaintain.vue",
    components: {
        offerDetailPopup,
        draggable,
        modifyChild,
        ResourceUpload,
        Ueditor
    },
    data() {
        return {
            parentId: null,//公司id
            // drag: false,
            picList: [],
            picList1: [],
            dragAndDrop: {
                "coverId": 0,//被拖拽的子项ID
                "schemeId": 0,//项目方案ID
                "takeId": 0,//将要交换位置的子项ID
                "budgetDescType": 0,
            },
            schemeBtnList: [], //方案默认按钮
            schemeList: [], //方案数据
            selectDatas: {},
            addValue: "",
            modifyChild: {},//修改子元素的数据
            previewDatas: [], //预览数据
            datas: {
                //请求接口的数据
                budgetDescs: [],
                id: null,
                schemeName: "", //方案名称
            },
            isShow: false,
            textarea: "",
            dialogVisible: false,
            swithBtn: ["出团说明", "确认单说明", "报价说明"],
            current: "出团说明",
            dialogImageUrl: "",
            dialogVisible1: false,
            exportType: 2,
            btnsList: {
                1: {
                    flag: true,
                    title: "常规",
                    arr: [],
                },
                2: {
                    flag: true,
                    title: "服务标准说明",
                    arr: [],
                },
                3: {
                    flag: true,
                    title: "行程外活动的安排",
                    arr: [],
                },
                4: {
                    flag: true,
                    title: "参团与安全风险提示",
                    arr: [],
                },
            },
        };
    },
    watch: {
        current() {
            this.$refs.offerDetailPopup.dialogVisible = false
        },
        dialogVisible() {
            this.$refs.offerDetailPopup.dialogVisible = false
        },
    },
    methods: {
        close() {
            this.current = '出团说明'
            this.$refs.upload.manualUpload(this.picList, this.parentId)
            this.$refs.upload1.manualUpload(this.picList1, this.parentId)
        },
        addChange(val) {
            console.log(val,'时刻打开时刻打开');
            
        },
        //更新数据
        update() {
            this.queryOptionList('compare');
        },
        //删除方案
        handlerDeleteClick(item) {
            console.log(item, '撒打算打算的');
            this.$confirm('此操作将永久删除该方案吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.queryByCompany()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //新增方案
        handlerAddClick() {
            this.datas = {
                budgetDescs: [
                    {
                        automatic: 1,
                        budgetDescType: 1, //类型code
                        budgetTitle: "",
                        budgetTitleContent: "",
                        companyId: null,
                        id: null,
                        schemeId: null,
                        sort: null,
                    },
                ],
                id: null,
                schemeName: "", //方案名称
            };
            this.queryOptionList();
            this.isShow = true;
            this.$forceUpdate()
            this.$refs.offerDetailPopup.dialogVisible = false
        },
        //右键触发事件
        rightClick(val) {
            this.modifyChild = JSON.parse(JSON.stringify(val))
            this.$refs.modifyChild.init(this.modifyChild)
            // val.editFlag = !val.editFlag
            console.log(val, '触发看看');
        },
        //开始拖拽
        onStart(val, keys) {

        },
        //拖拽结束
        onEnd(val, keys) {
            let arrs = this.btnsList[keys].arr
            this.dragAndDrop.coverId = arrs[val.newIndex].id ? arrs[val.newIndex].id : arrs[val.newIndex].diubId
            this.dragAndDrop.schemeId = arrs[val.oldIndex].schemeId ? arrs[val.oldIndex].schemeId : arrs[val.oldIndex].code
            this.dragAndDrop.takeId = arrs[val.oldIndex].id ? arrs[val.oldIndex].id : arrs[val.oldIndex].diubId
            this.dragAndDrop.budgetDescType = keys
            console.log(this.btnsList,keys,val,'是第九十九姐姐')
            // if (this.dragAndDrop.takeId != this.dragAndDrop.coverId) {
            //     new PlanApi("plan").dragAndDrop(this.dragAndDrop).then((res) => {
            //         if (res.status == 200) {
            //             this.queryOptionList('compare');

            //             // this.$message({
            //             //   message: "拖拽成功！",
            //             //   type: "success",
            //             // });
            //         } else {
            //             this.$message({
            //                 type: "error",
            //                 message: res.statusText,
            //             });
            //         }
            //     });
            // }
        },
        //选择报价类型按钮
        handlerSelectBtnClick(item) {
            console.log(item, "看看选择的数据");
            this.selectDatas = item;
            this.$forceUpdate()
            this.$refs.ueditor.dataHeardSplicing(item.budgetTitle)
        },
        //input失焦事件
        inputBlue(item, keys) {
            item.flag = true;
            if (
                this.addValue &&
                this.btnsList[keys].arr.findIndex(
                    (n) => n.budgetTitle === this.addValue
                ) === -1
            ) {
                let obj = JSON.parse(JSON.stringify(this.selectDatas));
                obj.budgetDescType = keys;
                obj.budgetTitle = this.addValue;
                obj.id = null;
                obj.companyId = null;
                obj.schemeId = null;
                obj.budgetTitleContent = "";
                this.btnsList[keys].arr.push(obj);
                this.addValue = "";
                this.handlerSelectBtnClick(obj);
            } else {
                this.$message({
                    message: "请勿重复添加！",
                    type: "warning",
                });
            }
        },
        // init(item) {
        //   console.log(item, '打瞌睡的看看');
        //     this.handlerSwithClick(item)
        //     this.dialogVisible = true;
        // },
        init(item) {
            console.log(item, '打瞌睡的看看');
            if (item) {
                this.handlerSwithClick(item)
            } else if (this.current !== '抬头纸上传') {
                this.handlerSwithClick('出团说明')
            }
            this.dialogVisible = true;
        },
        //添加说明按钮
        handlerAddBtnsClick(keys, item) {
            for (const key in this.btnsList) {
                this.btnsList[key].flag = true;
            }
            item.flag = false;
        },
        //保存说明接口
        save() {
            this.$refs.ueditor.getContent().then(res => {
                let datas = JSON.parse(JSON.stringify(this.datas));
                datas.htmlContentStr = res
                datas.exportType = this.exportType
                new PlanApi("plan").saveOrUpdateQuoted(datas).then((res) => {
                    if (res.status === 200) {
                        console.log("触发了接口", res);
                        this.queryByCompany(datas.id, 'save');
                        this.queryOptionList('compare');
                        this.$message({
                            message: "保存成功！",
                            type: "success",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.statusText,
                        });
                    }
                });
            })
        },
        //报价说明ID查询
        queryByCompany(id, type) {
            new PlanApi("plan").queryByCompanyId(this.exportType).then((res) => {
                if (res.status == 200) {
                    console.log("触发了接口", res);
                    this.schemeList = res.data;
                    if (id) {
                        let obj = this.schemeList.find(n => n.id === id)
                        this.handlerSelectClick(obj, 'hu')
                    } else if (type === 'save') {
                        this.handlerSelectClick(this.schemeList[this.schemeList.length - 1], 'hu')
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: res.statusText,
                    });
                }
            });
        },

        //报价说明默认按钮
        queryOptionList(type) {
            for (let btnsListKey in this.btnsList) {
                this.btnsList[btnsListKey].arr = []
            }
            new PlanApi("plan").queryOption({exportType: this.exportType}).then((res) => {
                if (res.status == 200) {
                    console.log("触发了接口", res.data);
                    res.data = duplicateRemoval(res.data, "budgetTitle");
                    console.log(res.data, "大大大");
                    res.data.sort((a, b) => a.sort - b.sort)
                    res.data.forEach((item, index) => {
                        // item.editFlag = false
                        // item.code = item.id
                        item.code = item.schemeId
                        item.diubId = item.id
                        item.budgetTitleContent = "";
                        item.companyId = null;
                        item.id = null;
                        item.schemeId = null;
                        if (type === "compare") {
                            this.previewDatas.forEach((item1) => {
                                if (item1.budgetTitle === item.budgetTitle) {
                                    res.data[index] = item1;
                                }
                            });
                        }
                    });
                    if (type !== "compare") {
                        if (res.data.length > 0) {
                            this.selectDatas = res.data[0];
                        } else {
                            this.selectDatas = JSON.parse(
                                JSON.stringify(this.datas.budgetDescs[0])
                            );
                        }
                    }
                    this.schemeBtnList = getGroup(res.data, "budgetDescType");
                    console.log(this.schemeBtnList, "看看接口数据");
                    for (const key in this.btnsList) {
                        for (const key1 in this.schemeBtnList) {
                            if (key === key1) {
                                this.btnsList[key].arr = this.schemeBtnList[key];
                            }
                        }
                    }
                    console.log(this.btnsList, "看看处理后的数据");
                } else {
                    this.$message({
                        type: "error",
                        message: res.statusText,
                    });
                }
            });
        },
        //按钮切换
        handlerSwithClick(item) {
            this.isShow = false
            this.selectDatas = {}
            this.current = item;
            "出团说明", "确认单说明", "报价说明"
            const map = {
                '出团说明': 2,
                '确认单说明': 1,
                '报价说明': 0
            }
            this.exportType = map[item]
            this.queryByCompany();
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        datasCl(obj) {
            let arrs = [];
            for (const key in obj) {
                obj[key].arr.forEach((item) => {
                    if (item.budgetTitleContent && item.budgetTitleContent != "") {
                        arrs.push(item);
                    }
                });
            }
            return arrs;
        },
        handlerSelectClick(item, type) {
            console.log(item, type, '看看书记9999');
            let arrs = item.budgetDescs.sort((a, b) => a.sort - b.sort)
            // this.previewDatas = this.datasCl(this.btnsList);
            if (type === "hu" && arrs.length > 0) {
                this.selectDatas = arrs[0];
                this.queryOptionList("compare");
                this.previewDatas = arrs;
            } else {
                // this.selectDatas = {};
                this.previewDatas = [];
                this.previewDatas = this.datasCl(this.btnsList);
                this.queryOptionList("compare");
            }
            this.datas = item;
            this.isShow = true;
            this.$nextTick(() => {
                this.$refs.offerDetailPopup.init(item.htmlContentStr)
                this.$refs.ueditor.setUeContent(item.htmlContentStr)
                console.log(this.selectDatas, "看看选择的方案");
            })
        },
        ueditorChange(v) {
            this.$refs.offerDetailPopup.dataUpdate(v)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible1 = true;
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
    border-radius: 0.25rem;
}

/deep/ .el-dialog2 .el-dialog__headerbtn {
    top: 0.1rem !important;
}

/deep/ .el-upload--picture-card {
    height: 1rem;
    width: 1rem;
    line-height: 1.05rem;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
    height: 1rem;
    width: 1rem;
}

/deep/ .input1 .el-input__inner {
    border: none;
    background-color: rgb(241, 241, 241);
    color: #f04848;
}

/deep/ .el-textarea__inner {
    border: none;
    border-bottom: 1px solid #e8e8e8;
}

.active {
    background-color: #ed7046 !important;
    color: #fff !important;
}

.active1 {
    background-color: #fbe6ba;
}

.active2 {
    color: #ed7046 !important;
}

// .inDrag {
//   height: 80px !important;
//   border: 1px solid #ED7046;
//   transition: all 0.2s ease;
//   padding-top: 10px;
//   padding-bottom: 10px;
//   width: 100%;
//   overflow-y: scroll;

// }

.title {
    padding-top: 0.2rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;

    .btns {
        width: 50%;
        height: 0.4rem;
        border: 1px solid #ed7046;
        background-color: #fff;
        color: #000;
        line-height: 0.4rem;
        text-align: center;
        cursor: pointer;

        &:nth-child(even) {
            border-right: none;
            border-left: none;
        }
    }
}

.container1 {
    .p1 {
        margin-right: 0.24rem;
        font-size: 0.12rem;
        color: #606266;
    }

    .box {
        display: flex;
        align-items: center;
        margin-bottom: 0.3rem;
    }
}

.container2 {
    .box-card {
        color: #8c8d90 !important;

        .line {
            height: 1px;
            border-bottom: 1px solid #e8e8e8;
            margin-bottom: 0.24rem;
        }

        .line1 {
            display: flex;
            align-items: center;
            margin-bottom: 0.24rem;

            .p5 {
                font-size: 0.12rem;
                width: 2rem;
            }

            .left {
                .btns {
                    width: 0.6rem;
                    font-size: 0.12rem;
                    background-color: #ffe5b4;
                    padding: 2px 3px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    border-radius: 5px;

                    &:hover {
                        color: red !important;
                    }
                }
            }

            .right {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                width: 100%;

                .btns {
                    display: inline-block;
                    min-width: 0.72rem;
                    // height: 0.3rem;
                    // text-align: center;
                    line-height: 0.3rem;
                    padding: 0px 5px;
                    border: 1px solid #fbe6ba;
                    margin-left: 0.1rem;
                    cursor: pointer;
                    position: relative;
                    margin-bottom: 0.1rem;

                    .checkIcon {
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        background-size: contain;
                        background-repeat: no-repeat;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                    }
                }
            }
        }

        .centerBox {
            min-height: 3rem;
            position: sticky;
            top: 0px;
            //border: 1px solid rgba(0, 0, 0, 0.09);

            .centerBoxTitle {
                height: 0.3rem;
                color: #ff6637;
                line-height: 0.3rem;
                padding-left: 0.2rem;
                font-size: 0.12rem;
                border-bottom: 1px solid #e8e8e8;
            }

            .centerBoxBottom {
                padding-left: 0.2rem;
                padding-bottom: 0.24rem;

                .p6 {
                    font-size: 0.12rem;
                    color: #606266;
                    margin-bottom: 0.1rem;
                }
            }
        }

        .footerBox {
            .p7 {
                color: #7a7b7f;
                font-size: 0.12rem;

                span {
                    color: #000;
                    border-bottom: 1px solid #000;
                    cursor: pointer;
                    margin-right: 0.12rem;
                }
            }
        }

        /*如果需要隐藏滚动条样式 则在标签上 加上 class = hiddenScrollbar*/
        .myUeditor {
            /deep/ .edui-editor {
                position: sticky;
                top: 0;
                height: 410px;
                overflow: scroll;
            }

            /deep/ .edui-editor-toolbarbox {
                position: sticky;
                top: 0;
                z-index: 9999;
            }

            /deep/ .ueditor-box {
            }
        }

        .footerBottomBtns {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            .bnts1 {
                border: 1px solid rgb(255, 102, 55);
                color: rgb(255, 102, 55);
                border-radius: 0.1rem;
                width: 1rem;
            }

            .btns2 {
                border: 1px solid rgb(255, 102, 55);
                color: #fff;
                border-radius: 0.1rem;
                background-color: rgb(255, 102, 55);
                width: 1rem;
            }
        }
    }

    .p1 {
        font-size: 0.12rem;
        color: rgb(2, 160, 198);
        font-weight: 400;
        margin-bottom: 0.12rem;
    }

    .p2 {
        color: #606266;
        font-size: 0.16rem;
        display: flex;
        align-items: center;
        margin-right: 0.24rem;
        width: 55%;
        margin-bottom: 0.12rem;

        .span1 {
            font-size: 0.12rem;
            font-family: "\9ED1\4F53";
        }

        .p3 {
            margin-left: auto;
            color: #dd7751;
            cursor: pointer;
        }
    }

    .priceSm {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 0.2rem;

        .priceSmText {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-right: 0.1rem;

            .p4 {
                font-size: 0.12rem;
                font-family: "\9ED1\4F53";
                color: #606266;
                margin-right: 0.06rem;
                border-bottom: 1px solid #ed7045;
            }

            .svg {
                color: #ed7045;
            }

            .el-icon-close {
                background-color: #ed6f47;
                color: #fff;
                font-size: 0.2rem;
                margin-left: 0.05rem;
            }
        }
    }
}
</style>
